























































































































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "@/api/ApiFactory";
import CbxEmploymentStatus from "@/views/lookups/CbxEmploymentStatus.vue";
import CbxOccupation from "@/views/lookups/CbxOccupation.vue";
import {
  FactFindEmploymentDto,
  CreateEmploymentCommand,
  OwnerDto,
  EmploymentStatusDto,
  OccupationDto,
  YesNoDefaultDto,
  UpdateEmploymentCommand,
  ClientSelector
} from "@/api/ClientPortalApiClient";
import CbxYesNoDefault from "@/views/lookups/CbxYesNoDefault.vue";
import CbxOwner from "@/views/lookups/CbxOwner.vue";
import AlertService from "../../services/alert.service";
import { LoadingSpinnerService } from "@/store";
import { FormatDate } from "@/filters/FormatDate";

@Component({
  components: {
    CbxOwner,
    CbxEmploymentStatus,
    CbxOccupation,
    CbxYesNoDefault
  }
})
export default class FactFindEmployments extends Vue {
  private alertService = new AlertService();
  private contactId: number = 0;
  private employments: FactFindEmploymentDto[] = [];
  private emptyEmployment = new FactFindEmploymentDto();
  private selectEmployment = new FactFindEmploymentDto();
  private displayModel = new FactFindEmploymentDto();
  private formEnabled: boolean = false;
  private mode: string = "default";
  private clientNames: OwnerDto[] = [];
  private modelSig = "";

  $refs!: {
    owner: CbxOwner;
    employementStatus: CbxEmploymentStatus;
    occupation: CbxOccupation;
    changeJob: CbxYesNoDefault;
    director: CbxYesNoDefault;
    mainForm: HTMLFormElement;
  };

  async created() {
    this.contactId = parseInt(this.$route.params.contactId);
    await this.getEmployments(true);
    await this.getClientSelectorNames();
  }

  private async getClientSelectorNames() {
    const api = ApiFactory.CreateDataClient();
    const data = await api.owner_Index(this.contactId);
    this.clientNames = data || [];
  }

  private employmentDisplayName(employment: FactFindEmploymentDto): string {
    const owner = this.clientNames.find(x => x.id === employment.client);
    return (owner ? owner.name : "") + " - " + (employment.employerName || "");
  }

  private saveEmployment(e: Event) {
    e.preventDefault();
    if (this.mode === "update") {
      this.update();
    } else if (this.mode === "create") {
      this.createNew();
    }
  }

  private async createNew(): Promise<boolean> {
    LoadingSpinnerService.Show("Saving new Employment...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new CreateEmploymentCommand();

    cmd.contactId = this.contactId;
    cmd.client = this.displayModel.client;
    cmd.occupation = this.displayModel.occupation;
    cmd.jobDescription = this.displayModel.jobDescription;
    cmd.employerName = this.displayModel.employerName;
    cmd.employerAddressLine_1 = this.displayModel.employerAddressLine_1;
    cmd.employerAddressLine_2 = this.displayModel.employerAddressLine_2;
    cmd.employerAddressLine_3 = this.displayModel.employerAddressLine_3;
    cmd.employerAddressLine_4 = this.displayModel.employerAddressLine_4;
    cmd.employerAddressLine_5 = this.displayModel.employerAddressLine_5;
    cmd.plansToChangeJobTimeFrame = this.displayModel.plansToChangeJobTimeFrame;
    cmd.retirementAge = this.displayModel.retirementAge;
    cmd.shareholdingPercentage = this.displayModel.shareholdingPercentage;
    cmd.notes = this.displayModel.notes;
    cmd.endDate = FormatDate.forApi(this.displayModel.endDate);
    cmd.startDate = FormatDate.forApi(this.displayModel.startDate);
    cmd.employmentDate = FormatDate.forApi(this.displayModel.employmentDate);
    if (this.displayModel.isDirector) {
      cmd.isDirectorId = this.displayModel.isDirector.id;
    }
    if (this.displayModel.plansToChangeJob) {
      cmd.plansToChangeJobId = this.displayModel.plansToChangeJob.id;
    }
    if (this.displayModel.employmentStatus) {
      cmd.employmentStatusId = this.displayModel.employmentStatus.id;
    }

    try {
      const result = await api.factFindEmployment_IndexPOST(cmd);
      this.displayModel.id = result;
      await this.getEmployments();
      this.displayModel =
        this.employments.find(x => x.id === result) || this.displayModel;
      this.mode = "update";
      this.modelSig = this.displayModel.toJSON();
      LoadingSpinnerService.Success("Employment saved successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Could not save Employment. Please try again."
      );
    }

    return false;
  }

  private async update(): Promise<boolean> {
    LoadingSpinnerService.Show("Updating Employment...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new UpdateEmploymentCommand();

    cmd.contactId = this.contactId;
    cmd.id = this.displayModel.id;
    cmd.client = this.displayModel.client;
    cmd.occupation = this.displayModel.occupation;
    cmd.jobDescription = this.displayModel.jobDescription;
    cmd.employerName = this.displayModel.employerName;
    cmd.employerAddressLine_1 = this.displayModel.employerAddressLine_1;
    cmd.employerAddressLine_2 = this.displayModel.employerAddressLine_2;
    cmd.employerAddressLine_3 = this.displayModel.employerAddressLine_3;
    cmd.employerAddressLine_4 = this.displayModel.employerAddressLine_4;
    cmd.employerAddressLine_5 = this.displayModel.employerAddressLine_5;
    cmd.plansToChangeJobTimeFrame = this.displayModel.plansToChangeJobTimeFrame;
    cmd.retirementAge = this.displayModel.retirementAge;
    cmd.shareholdingPercentage = this.displayModel.shareholdingPercentage;
    cmd.notes = this.displayModel.notes;
    cmd.endDate = FormatDate.forApi(this.displayModel.endDate);
    cmd.startDate = FormatDate.forApi(this.displayModel.startDate);
    cmd.employmentDate = FormatDate.forApi(this.displayModel.employmentDate);

    if (this.displayModel.isDirector) {
      cmd.isDirectorId = this.displayModel.isDirector.id;
    }
    if (this.displayModel.plansToChangeJob) {
      cmd.plansToChangeJobId = this.displayModel.plansToChangeJob.id;
    }
    if (this.displayModel.employmentStatus) {
      cmd.employmentStatusId = this.displayModel.employmentStatus.id;
    }

    try {
      var result = await api.factFindEmployment_IndexPUT(cmd);
      if (result) {
        this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
        LoadingSpinnerService.Success("Employment updated successfully");
        return true;
      } else {
        LoadingSpinnerService.Failure(
          "Could not save Employment. Please try again."
        );
      }
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Could not save Employment. Please try again."
      );
    }

    return false;
  }

  private async getEmployments(showLoader: boolean | undefined = undefined) {
    if (showLoader) LoadingSpinnerService.Show("Loading Employments...");
    const api = ApiFactory.CreateDataClient();
    try {
      const result = await api.factFindEmployment_IndexAll(this.contactId);
      this.employments = result || [];
      if (showLoader) LoadingSpinnerService.Hide();
    } catch (e) {
      this.employments = [];
      LoadingSpinnerService.Failure(
        "Could not load Employments. Please try again."
      );
    }
  }

  private async rowSelected(item: FactFindEmploymentDto) {
    if (!(await this.checkForChanges())) {
      return;
    }

    this.clearData();
    this.formEnabled = true;
    this.mode = "update";
    this.displayModel = item;

    if (this.displayModel.client) {
      this.$refs.owner.setSelected(this.displayModel.client);
    } else {
      this.$refs.owner.setSelected(ClientSelector.Main);
    }

    this.displayModel.endDate = FormatDate.forInput(item.endDate);
    this.displayModel.startDate = FormatDate.forInput(item.startDate);
    this.displayModel.employmentDate = FormatDate.forInput(item.employmentDate);

    this.$refs.director.setSelected(this.displayModel.isDirector);
    this.$refs.changeJob.setSelected(this.displayModel.plansToChangeJob);

    if (this.displayModel.occupation) {
      this.$refs.occupation.setSelectedName(this.displayModel.occupation);
    } else {
      this.$refs.occupation.setSelected(new OccupationDto());
    }

    this.$refs.employementStatus.setSelected(
      this.displayModel.employmentStatus
    );

    this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
  }

  private saveClicked() {
    this.formEnabled = false;
    this.clearData();
    this.mode = "default";
  }

  private createClicked() {
    this.clearData();
    this.mode = "create";
    this.formEnabled = true;
  }

  private clearData() {
    this.displayModel = this.emptyEmployment;
    this.displayModel.client = ClientSelector.Main;
    this.$refs.owner.setSelected(ClientSelector.Main);
    this.$refs.director.setSelected(new YesNoDefaultDto());
    this.$refs.changeJob.setSelected(new YesNoDefaultDto());
    this.$refs.occupation.setSelected(new OccupationDto());
    this.$refs.employementStatus.setSelected(new EmploymentStatusDto());
  }

  public async checkForChanges(): Promise<boolean> {
    if (this.isDisplayModelEmpty() == false) {
      if (this.hasChanges() == true) {
        if (confirm("Would you like to save your changes?")) {
          return await this.saveChanges();
        }
      }
    }

    return true;
  }

  public async saveChanges(): Promise<boolean> {
    if (this.$refs.mainForm.checkValidity()) {
      if (this.mode === "update") {
        return await this.update();
      } else if (this.mode === "create") {
        return await this.createNew();
      }

      return true;
    }

    this.alertService.error(
      "Form Validation Failed",
      "Please complete all required fields"
    );
    return false;
  }

  private isDisplayModelEmpty(): boolean {
    return (
      this.mode !== "create" &&
      JSON.stringify(this.displayModel.toJSON()) ===
        JSON.stringify(this.emptyEmployment.toJSON())
    );
  }

  private hasChanges(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    if (s1 !== this.modelSig) {
      return true;
    } else {
      return false;
    }
  }

  private ownerSelected(owner: ClientSelector) {
    this.displayModel.client = owner;
  }
  private employmentStatusSelected(employementStatus: EmploymentStatusDto) {
    this.displayModel.employmentStatus = employementStatus;
  }
  private occupationSelected(occupation: OccupationDto) {
    this.displayModel.occupation = occupation.name;
  }
  private changeJobSelected(changeJob: YesNoDefaultDto) {
    this.displayModel.plansToChangeJob = changeJob;
  }
  private directorSelected(director: YesNoDefaultDto) {
    this.displayModel.isDirector = director;
  }
}
